(function() {
  'use strict';

  const RWRSizeGuideWovenNylon = {
    init: function() {
      this.section = document.querySelector('.rwr-size-guide-woven-nylon');
      if (!this.section) return;
      
      this.bindEvents();
      this.initAccessibility();
    },

    bindEvents: function() {
      const tableRows = this.section.querySelectorAll('.rwr-size-guide__table tbody tr');
      
      tableRows.forEach(row => {
        row.setAttribute('tabindex', '0');
        
        row.addEventListener('focus', function() {
          this.classList.add('is-focused');
        });
        
        row.addEventListener('blur', function() {
          this.classList.remove('is-focused');
        });
      });
    },

    initAccessibility: function() {
      const table = this.section.querySelector('.rwr-size-guide__table');
      if (table) {
        table.setAttribute('role', 'table');
        table.setAttribute('aria-label', 'Woven nylon dog collar size chart');
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RWRSizeGuideWovenNylon.init());
  } else {
    RWRSizeGuideWovenNylon.init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.rwr-size-guide-woven-nylon')) {
      RWRSizeGuideWovenNylon.init();
    }
  });
})();